module.exports = __webpack_public_path__ + "static/use-case-3-content-5-f66129810738afa7c6e0f41bd0c45432.png";